// Laces & Soles — Theme JS

// Cart drawer toggle
function toggleCart() {
  document.getElementById('cartDrawer').classList.toggle('open');
  document.getElementById('cartOverlay').classList.toggle('open');
}

// Notification
function showNotif(msg) {
  const n = document.getElementById('notif');
  if (msg) n.textContent = msg;
  n.classList.add('show');
  setTimeout(() => n.classList.remove('show'), 2500);
}

// Update cart drawer via Shopify AJAX API
function refreshCartDrawer() {
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      const btn = document.querySelector('.cart-toggle-btn');
      if (btn) btn.textContent = `BAG (${cart.item_count})`;

      const itemsEl = document.getElementById('cartItemsDrawer');
      const footerEl = document.getElementById('cartFooterDrawer');
      const totalEl = document.getElementById('cartTotalDrawer');

      if (!itemsEl) return;

      if (cart.item_count === 0) {
        itemsEl.innerHTML = '<div class="cart-empty">Your bag is empty.<br>Time to cop something.</div>';
        if (footerEl) footerEl.style.display = 'none';
        return;
      }

      if (footerEl) footerEl.style.display = 'block';
      if (totalEl) totalEl.textContent = formatMoney(cart.total_price);

      itemsEl.innerHTML = cart.items.map(item => `
        <div class="cart-item">
          <img class="cart-item__img" src="${item.image}" alt="${item.title}">
          <div style="flex:1">
            <div class="cart-item__name">${item.product_title}</div>
            <div class="cart-item__meta">${item.variant_title !== 'Default Title' ? item.variant_title : ''} &nbsp; Qty: ${item.quantity}</div>
            <div class="cart-item__price">${formatMoney(item.line_price)}</div>
            <button onclick="removeCartItem(${item.variant_id})" style="background:none;border:none;font-size:10px;color:#888;letter-spacing:1px;text-transform:uppercase;margin-top:6px;cursor:pointer;">Remove</button>
          </div>
        </div>
      `).join('');
    });
}

function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2);
}

function removeCartItem(variantId) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 0 })
  }).then(() => refreshCartDrawer());
}

// Add to cart via AJAX
function addToCart(variantId, quantity) {
  quantity = quantity || 1;
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: quantity })
  })
  .then(r => r.json())
  .then(() => {
    refreshCartDrawer();
    showNotif('Added to bag ✓');
    toggleCart();
  })
  .catch(() => showNotif('Something went wrong'));
}

// Variant selector on product page
document.addEventListener('DOMContentLoaded', function () {
  refreshCartDrawer();

  // Variant buttons
  const variantBtns = document.querySelectorAll('.variant-btn');
  variantBtns.forEach(btn => {
    btn.addEventListener('click', function () {
      variantBtns.forEach(b => b.classList.remove('active'));
      this.classList.add('active');
      const form = document.querySelector('.product-form');
      if (form) {
        const input = form.querySelector('input[name="id"]');
        if (input) input.value = this.dataset.variantId;
      }
    });
  });

  // Product form submit
  const productForm = document.querySelector('.product-form');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const variantId = this.querySelector('input[name="id"]').value;
      const qty = this.querySelector('input[name="quantity"]') ? parseInt(this.querySelector('input[name="quantity"]').value) : 1;
      if (!variantId) { showNotif('Please select a size'); return; }
      addToCart(variantId, qty);
    });
  }

  // Quick add buttons
  document.querySelectorAll('.product-card__quick-add').forEach(btn => {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      const variantId = this.dataset.variantId;
      if (variantId) addToCart(variantId, 1);
    });
  });

  // Marquee
  const track = document.getElementById('marqueeTrack');
  if (track) {
    const items = ['Laces & Soles', '★ New Collection', 'Free Shipping $100+', '★ Virginia Beach', 'Limited Drops', '★ Premium Streetwear', 'Hoodies · Tees · Denim', '★ Shop Now'];
    const doubled = [...items, ...items, ...items];
    track.innerHTML = doubled.map(t =>
      `<span class="marquee-item">${t.replace('★', '<span class="dot">★</span>')}</span>`
    ).join('');
  }
});
